export interface FileUploadResponse {
  fileId: number;
  uri: string;
}
